export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Video Player';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Video source';

  const media = document.createElement('div');
  media.className = 'ew-media';

  const video = document.createElement('video');
  video.controls = node.props?.controls !== false;
  video.loop = Boolean(node.props?.loop);
  video.autoplay = Boolean(node.props?.autoplay);
  video.muted = Boolean(node.props?.muted);
  if (node.props?.poster) video.poster = node.props.poster;

  const applySource = (src) => {
    media.innerHTML = '';
    if (!src) {
      media.appendChild(makePlaceholder('No video source'));
      return;
    }
    video.src = src;
    media.appendChild(video);
  };

  applySource(node.data?.src || node.props?.src || '');

  video.addEventListener('ended', () => {
    api.emit('node:input', { id: node.id, field: 'ended', value: true });
  });

  body.append(label, media);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Video Player';
      label.textContent = next.props?.label || 'Video source';
      video.controls = next.props?.controls !== false;
      video.loop = Boolean(next.props?.loop);
      video.autoplay = Boolean(next.props?.autoplay);
      video.muted = Boolean(next.props?.muted);
      video.poster = next.props?.poster || '';
      const src = next.data?.src || next.props?.src || '';
      if (video.getAttribute('src') !== src) applySource(src);
    }
  };
}

function makePlaceholder(text) {
  const el = document.createElement('div');
  el.className = 'ew-media-placeholder';
  el.textContent = text;
  return el;
}
